package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class RequirementRepository(private val httpClient: HttpClient) {
    suspend fun getRequirements(workplaceId: Long): Result<List<WorkplaceRequirementDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/requirements").body()
    }

    suspend fun createRequirement(workplaceId: Long, req: CreateWorkplaceRequirementRequest): Result<Long> = runCatching {
        httpClient.post("workplaces/$workplaceId/requirements") {
            setBody(req)
        }.body<Map<String, Long>>()["id"]!!
    }

    suspend fun deleteRequirement(workplaceId: Long, reqId: Long): Result<Unit> = runCatching {
        httpClient.delete("workplaces/$workplaceId/requirements/$reqId")
    }

    suspend fun updateRequirement(workplaceId: Long, reqId: Long, req: CreateWorkplaceRequirementRequest): Result<Unit> = runCatching {
        httpClient.put("workplaces/$workplaceId/requirements/$reqId") {
            setBody(req)
        }
    }
}
